import {CHECK_TOKEN_FEEDBACK_URL, GET_FEEDBACK_REPLY_FORM, SEND_FEEDBACK_REPLY_FORM} from './constants'

export function checkFeedbackToken (token) {
  return axios
    .get(CHECK_TOKEN_FEEDBACK_URL, {params: {feedback_token: token}})
    .then(response => {
      return Promise.resolve(response)
    }).catch(error => {
      return Promise.reject(error.response)
    })
}

export function getFeedbackReplyForm (feedbackId) {
  return axios
    .get(GET_FEEDBACK_REPLY_FORM(feedbackId), {})
    .then(response => {
      return Promise.resolve(response)
    }).catch(error => {
      return Promise.reject(new Error(error.message))
    })
}

export function sendFeedbackReplyForm (data) {
  return axios
  // TODO: please comunication with backend team for change structure of params
    .post(SEND_FEEDBACK_REPLY_FORM, {comment: data.message, feedback_token: data.token}, { withCredentials: true })
    .then(response => {
      return Promise.resolve(response)
    }).catch(error => {
      const {response} = error
      return Promise.reject(response)
    })
}



// WEBPACK FOOTER //
// ./app/api/feedbackReplyForm/index.js